import api from '../../../services/Api';
import { IAuditoriaRoundTrippingResultado } from '../interfaces/IAuditoriaRoundTripping';

interface BuscarParams {
  empresaId: number;
  periodo?: string;
}

const resultadoVazio: IAuditoriaRoundTrippingResultado = {
  passivoTotalGeral: 0,
  tributoPrincipalTotal: 0,
  multaQualificadaTotal: 0,
  jurosSelicTotal: 0,
  totalErros: 0,
  totalAlertas: 0,
  totalAvisos: 0,
  status: 'CONCILIADO',
  mensagemDirecionamento: '',
  fundamentacaoLegal: '',
  itens: [],
};

export const AuditoriaRoundTrippingService = {
  async buscarResultado(params: BuscarParams): Promise<IAuditoriaRoundTrippingResultado> {
    const response = await api.get<IAuditoriaRoundTrippingResultado>(
      'auditoria-round-tripping/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo || '' } }
    );
    return response.data || resultadoVazio;
  },
};
